import React, { useState, useRef } from 'react';
import { useTranslation } from '../../LanguageContext';
import styles from './Questions.module.css';

const FAQ = () => {
  const { t, isEnglish } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(null);
  const contentRefs = useRef([]);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqData = t.faq.items;

  return (
    <section className={styles.faqSection}>
      {/* Background Elements */}
      <div className={styles.bgGradient}></div>
      <div className={styles.floatingOrb}></div>
      
      <div className={styles.container}>
        <div className={styles.headerSection}>
          <span className={styles.badge}>{t.faq.badge}</span>
          <h2 className={styles.title}>{t.faq.title}</h2>
          <p className={styles.subtitle}>
            {t.faq.subtitle}
          </p>
        </div>

        <div className={styles.faqContainer}>
          {faqData.map((item, index) => (
            <div 
              key={index}
              className={`${styles.faqItem} ${activeIndex === index ? styles.active : ''}`}
            >
              <button 
                className={styles.faqQuestion}
                onClick={() => toggleFAQ(index)}
                aria-expanded={activeIndex === index}
              >
                <span className={styles.questionText}>{item.question}</span>
                <div className={styles.iconWrapper}>
                  <span className={styles.icon}>
                    <svg 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2"
                      className={styles.iconSvg}
                    >
                      <path d="M12 5v14M5 12h14" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </span>
                </div>
              </button>
              <div 
                className={styles.faqAnswer}
                ref={(el) => (contentRefs.current[index] = el)}
                style={{
                  maxHeight: activeIndex === index 
                    ? `${contentRefs.current[index]?.scrollHeight + 40}px` 
                    : '0px'
                }}
              >
                <div className={styles.answerContent}>
                  <p className={styles.answerText}>{item.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.ctaSection}>
          <p className={styles.ctaText}>{t.faq.ctaText}</p>
          <a 
            href="https://wa.me/972544998929?text=%D7%94%D7%99%D7%99%20%D7%A0%D7%A8%D7%A7%D7%99%D7%A1%20%D7%94%D7%92%D7%A2%D7%AA%D7%99%20%D7%9E%D7%94%D7%93%D7%A3%20%D7%A9%D7%9C%D7%9A%2C%20%D7%99%D7%A9%20%D7%9C%D7%99%20%D7%A2%D7%95%D7%93%20%D7%A9%D7%90%D7%9C%D7%94"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.ctaButton}
            style={{ textDecoration: 'none' }}
          >
            <span>{t.faq.ctaButton}</span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;